export enum PHVType {
    Reaction = 6
}

export interface PHV {
    listType: Undefinable<PHVType>;
    conceptCode: Undefinable<string>;
    conceptName: Undefinable<string>;
}
